<template>
    <div class="opui-row">
        <div class="opui-col">
            <RichSelect
                v-model="item.action"
                modelValue="item.action"
                :options="actionGroups"
                :placeholder="'Choose an action'"
                :required="true"
            >
            </RichSelect>
        </div>
    </div>

    <div class="opui-row" v-if="item.action">
        <div class="opui-col">
            <AddToMembership              v-if="item.action === 'action/mentor/add-to-membership'"        :workflow="workflow" :item="item"  />
            <RemoveFromMembership         v-if="item.action === 'action/mentor/remove-from-membership'"   :workflow="workflow" :item="item"  />
            <OptinForm                    v-if="item.action === 'action/builder/optin'"                   :workflow="workflow" :item="item"  />
            <WebhookForm                  v-if="item.action === 'action/general/webhook'"                 :workflow="workflow" :item="item" />
            <RUAAddToMembership           v-if="item.action === 'action/rua/add-to-membership'"           :workflow="workflow" :item="item"  />
            <RUARemoveFromMembership      v-if="item.action === 'action/rua/remove-from-membership'"      :workflow="workflow" :item="item"  />
            <KoursesAddToMembership       v-if="item.action === 'action/kourses/add-to-membership'"       :workflow="workflow" :item="item"  />
            <KoursesRemoveFromMembership  v-if="item.action === 'action/kourses/remove-from-membership'"  :workflow="workflow" :item="item"  />
            <WishlistAddToMembership      v-if="item.action === 'action/wishlist/add-to-membership'"      :workflow="workflow" :item="item"  />
            <WishlistRemoveFromMembership v-if="item.action === 'action/wishlist/remove-from-membership'" :workflow="workflow" :item="item"  />
        </div>
    </div>
</template>

<script>
import AddToMembership from "../Actions/AddToMembership.vue"
import KoursesAddToMembership from "../Actions/KoursesAddToMembership.vue"
import KoursesRemoveFromMembership from "../Actions/KoursesRemoveFromMembership.vue"
import OptinForm from "../Actions/OptinForm.vue"
import RemoveFromMembership from "../Actions/RemoveFromMembership.vue"
import RichSelect from "../../Global/RichSelect.vue"
import RUAAddToMembership from "../Actions/RUAAddToMembership.vue"
import RUARemoveFromMembership from "../Actions/RUARemoveFromMembership.vue"
import WebhookForm from "../Actions/WebhookForm.vue"
import WishlistAddToMembership from "../Actions/WishlistAddToMembership.vue"
import WishlistRemoveFromMembership from "../Actions/WishlistRemoveFromMembership.vue"

export default {
    components: {
        AddToMembership, KoursesAddToMembership, KoursesRemoveFromMembership, OptinForm, RemoveFromMembership,
        RichSelect, RUAAddToMembership, RUARemoveFromMembership, WebhookForm,
        WishlistAddToMembership, WishlistRemoveFromMembership
    },
    props: {
        item:     { type: Object, required: true },
        workflow: { type: Object, required: true },
    },
    mounted() {
        if (! this.item.settings) {
            this.item.settings = {
                "membership_id": "all", "membership_title": "- All memberships -",
            }
        }
    },
    computed: {
        /**
         * Create trigger groups for dropdown
         * @returns {*[]}
         */
        actionGroups() {
            let groups = []

            // We also need info on items to exclude
            let triggerKey    = this.workflow.triggers[0].event
            let triggerConfig = this.findTriggerConfig(triggerKey)
            let excludeGroups = triggerConfig.exclude_groups ? triggerConfig.exclude_groups : []
            let excludeItems  = triggerConfig.exclude_items  ? triggerConfig.exclude_items  : []
            // console.log(excludeItems)
            // console.log(excludeGroups)

            Object.entries(window.OptimizeFlow.config.action_groups).forEach(entry => {
                const [key, item] = entry;

                if (window.OptimizeFlow.config.action_groups) {
                    const group = { id: key, text: item.title, active: item.active, children: [] }

                    if (item.active && item.actions) {
                        Object.entries(item.actions).forEach(triggerEntry => {
                            const [actionKey, actionItem] = triggerEntry;

                            if (actionItem.active && ! excludeItems.includes(actionKey)) {
                                group.children.push({ id: actionKey, text: actionItem.title })
                            }
                        })
                    }

                    // Only add to list if active and not excluded by trigger
                    if (group.active && ! excludeGroups.includes(key)) {
                        groups.push(group)
                    }
                }
            })

            return groups
        }
    },
    methods: {
        /**
         * Update the selected text
         */
        actionChange(selected) {
            this.item.title = selected.text
        },
    }
}
</script>
